import * as CryptoJS from 'crypto-js';

export type PersistKey = 'authentication' | 'csrf' | 'gameon.neoSessionToken';

class PersistStorage {
  private encryptKey = 'po_ncel';

  private storagePrefix = (): string => 'po_ncel_';
  private getLocalStorageKey = (key: PersistKey): string => `${this.storagePrefix()}${key}`;

  private encrypt = (value: string): string => CryptoJS.AES.encrypt(value, CryptoJS.MD5(this.encryptKey).toString()).toString();

  private decrypt = (value: string): string =>
    CryptoJS.AES.decrypt(value, CryptoJS.MD5(this.encryptKey).toString()).toString(CryptoJS.enc.Utf8);

  public setItem = (key: PersistKey, value?: {}): void => {
    if (!value) {
      this.removeItem(key);
      return;
    }
    localStorage.setItem(this.getLocalStorageKey(key), this.encrypt(JSON.stringify(value)));
  };

  public getItem = (key: PersistKey): {} | null => {
    const item = localStorage.getItem(this.getLocalStorageKey(key));
    if (!item) {
      return null;
    }
    try {
      const value = this.decrypt(item);
      return JSON.parse(value);
    } catch {
      return null;
    }
  };

  public removeItem = (key: PersistKey, _value?: {}): void => {
    localStorage.removeItem(this.getLocalStorageKey(key));
  };
}

export const persistStorage = new PersistStorage();
